import React from 'react';
import styles from '../Dashboard.module.css';
import AssignmentsSummaryCard from './AssignmentsSummaryCard';
import QuizzesSummaryCard from './QuizzesSummaryCard';
import CoursesSummaryCard from './CoursesSummaryCard';
import NotesSummaryCard from './NotesSummaryCard';

// The My-Assignments / My-Quizzes / My-Courses / My-Notes summary cards
// row (student view only). Extracted VERBATIM from Dashboard's render.
export default function DashboardSummaryCards({ assignmentSummary, enrolledCourses, formatDueDate, getAssignmentStatus, getQuizStatus, handleAssignmentClick, handleCourseClick, handleQuizClick, navigate, notesSummary, quizSummary, recentAssignments, recentNotes, recentQuizzes, setShowPreviousCourses, showPreviousCourses }) {
  return (
    <>
      {/* Row 1: Hero Assignments + Quizzes */}
      <div className={styles.topRow}>
        <AssignmentsSummaryCard
          assignmentSummary={assignmentSummary}
          formatDueDate={formatDueDate}
          getAssignmentStatus={getAssignmentStatus}
          handleAssignmentClick={handleAssignmentClick}
          recentAssignments={recentAssignments}
        />
        <QuizzesSummaryCard
          formatDueDate={formatDueDate}
          getQuizStatus={getQuizStatus}
          handleQuizClick={handleQuizClick}
          quizSummary={quizSummary}
          recentQuizzes={recentQuizzes}
        />
      </div>

      {/* Row 2: Courses + Notes (Courses first for mobile priority) */}
      <div className={styles.secondRow}>
        <CoursesSummaryCard
          enrolledCourses={enrolledCourses}
          handleCourseClick={handleCourseClick}
          setShowPreviousCourses={setShowPreviousCourses}
          showPreviousCourses={showPreviousCourses}
        />
        <NotesSummaryCard
          navigate={navigate}
          notesSummary={notesSummary}
          recentNotes={recentNotes}
        />
      </div>
    </>
  );
}
